var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpectLineMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 956.702,
    viewBox: "0 0 30 956.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(-172.5 -2730.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M0,0H215.381",
    transform: "translate(189.738 3104.174) rotate(90)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M0,0H201.111",
    transform: "translate(189.738 3353.655) rotate(90)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M0,0H92.943",
    transform: "translate(189.738 3588.772) rotate(90)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M3411.354,4026.363l9.715,9.715-9.715,9.716",
    transform: "translate(4225.493 263.647) rotate(90)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(172.365 3321.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 26,
    height: 26,
    rx: 5,
    transform: "translate(4.135 3.868)",
    fill: "#72beb7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    transform: "translate(0.135 -0.132)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3-2",
    "data-name": 3,
    transform: "translate(13.135 19.868)",
    fill: "#8f6f6f",
    fontSize: 19,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(172.999 3071.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196-2",
    "data-name": "Rectangle 196",
    width: 26,
    height: 26,
    rx: 5,
    transform: "translate(3.501 3.868)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195-2",
    "data-name": "Rectangle 195",
    transform: "translate(-0.499 -0.132)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2-2",
    "data-name": 2,
    transform: "translate(13.501 19.868)",
    fill: "#8f6f6f",
    fontSize: 19,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(172.482 3556.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196-3",
    "data-name": "Rectangle 196",
    width: 26,
    height: 26,
    rx: 5,
    transform: "translate(4.018 3.868)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195-3",
    "data-name": "Rectangle 195",
    transform: "translate(0.018 -0.132)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(13.018 19.868)",
    fill: "#8f6f6f",
    fontSize: 19,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5,
    y: 0
  }, "4"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M0,0H97.337",
    transform: "translate(189.738 2747.477) rotate(90)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M0,0H192.738",
    transform: "translate(189.738 2877.564) rotate(90)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    transform: "translate(199.5 2730.842) rotate(90)",
    fill: "#fff",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 10,
    rx: 7.5,
    ry: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(172.949 2845.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196-4",
    "data-name": "Rectangle 196",
    width: 26,
    height: 26,
    rx: 5,
    transform: "translate(3.551 3.868)",
    fill: "#f6cf85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_195-4",
    "data-name": "Rectangle 195",
    transform: "translate(-0.449 -0.132)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(13.551 19.868)",
    fill: "#8f6f6f",
    fontSize: 19,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "1"))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectLineMobile);
export default __webpack_public_path__ + "static/media/expectLineMobile.593e7dad5d8ceda0df17c28dffdbc433.svg";
export { ForwardRef as ReactComponent };